import React from "react";

const CustomPlansIcon = (props: any) => {
  return (
    <svg width={20} height={20} fill="none" {...props}>
      <path
        fill="var(--color-blue)"
        d="M14.683 8.016h-4.375a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h4.375a.624.624 0 1 1 0 1.25ZM5.933 8.65a.618.618 0 0 1-.441-.183l-.625-.625a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l.183.183 1.434-1.433a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883L6.375 8.467a.624.624 0 0 1-.442.183ZM14.683 13.852h-4.375a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h4.375a.624.624 0 1 1 0 1.25ZM5.933 14.482a.618.618 0 0 1-.441-.183l-.625-.625a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l.183.183 1.434-1.433a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883l-1.875 1.875a.625.625 0 0 1-.442.183Z"
      />
      <path
        fill="var(--color-blue)"
        d="M12.5 18.96h-5c-4.525 0-6.458-1.934-6.458-6.459v-5c0-4.525 1.933-6.458 6.458-6.458h5c4.525 0 6.458 1.933 6.458 6.458v5c0 4.525-1.933 6.459-6.458 6.459Zm-5-16.667c-3.842 0-5.208 1.367-5.208 5.208v5c0 3.842 1.366 5.209 5.208 5.209h5c3.841 0 5.208-1.367 5.208-5.209v-5c0-3.841-1.366-5.208-5.208-5.208h-5Z"
      />
    </svg>
  );
};

export default CustomPlansIcon;
